import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WebcamImage } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';
import { base64StringToBlob } from 'blob-util'
import { ToastService } from 'src/app/core/services/toast-service.service';
import { Dependent } from 'src/app/core/models/dependent';
import { DependentService } from 'src/app/core/services/general/dependent.service';
import { AlertService } from 'src/app/core/services/alert.service';

@Component({
  selector: 'app-member-face-verification',
  templateUrl: './member-face-verification.component.html',
  styleUrls: ['./member-face-verification.component.scss']
})

export class MemberFaceVerificationComponent {
  @Input() dependent!: Dependent;

  public trigger: Subject<void> = new Subject<void>();
  public webcamImage?: WebcamImage;
  public loading: boolean = false;

  public videoOptions: MediaTrackConstraints = {
    width: { ideal: 400 },
    height: { ideal: 400 }
  };


  constructor(
    public activeModal: NgbActiveModal,
    private toastService: ToastService,
    private alertService: AlertService,
    private dependentService: DependentService
  ) {

  }

  convertWebcamImageToBlob() {
    const base64Data = this.webcamImage!.imageAsBase64;
    return base64StringToBlob(base64Data);
  }


  verifyMemberPhoto() {
    this.loading = true;
    const formData = new FormData();
    formData.append(
      'member_number',
      this.dependent.member_number
    );
    formData.append(
      'beneficiary_number',
      this.dependent.beneficiary_number
    );
    formData.append(
      'member_photo_file',
      this.convertWebcamImageToBlob()
    );
    this.dependentService.verifyMemberPhoto(formData).subscribe({
      next: (res: any) => {
        this.loading = false;
        this.activeModal.close(res);
      },
      error: (err: any) => {
        this.loading = false;
        this.alertService.showNotificationForHttpError(err);
      }
    });
  }


  public triggerSnapshot(): void {
    this.trigger.next();
  }

  public clearSnapshot(): void {
    this.webcamImage = undefined;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public handleImage(webcamImage: WebcamImage): void {
    this.webcamImage = webcamImage;
    this.convertWebcamImageToBlob();
    this.verifyMemberPhoto();
  }
}
